import React from "react";
import { motion } from "framer-motion";
import { useT } from "../i18n/LanguageContext";

export const Filosofia = () => {
  const { t } = useT();
  const x = t.filosofia;
  return (
    <section className="relative section-pad section-pad-bottom-tight overflow-hidden" data-testid="filosofia-section">
      <div className="absolute inset-0 grain pointer-events-none" />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vw] max-w-[900px] max-h-[900px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(212,97,42,0.10) 0%, transparent 60%)" }}
      />
      <div className="relative max-w-[980px] mx-auto text-center">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          transition={{ duration: 0.7 }} className="eyebrow"
        >
          {x.eyebrow}
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 1.2, ease: [0.22, 0.61, 0.36, 1] }}
          className="mt-7 font-display font-light text-[34px] sm:text-[48px] md:text-[68px] lg:text-[82px] leading-[1.05] tracking-[-0.012em] text-[var(--pn-milk)]"
        >
          <span className="text-[var(--pn-amber)] italic">{x.title_a}</span>
          <span className="text-[var(--pn-cream)]/85">{x.title_a2}</span>
          <br />
          <span className="text-[var(--pn-amber)] italic">{x.title_b}</span>
          <span className="text-[var(--pn-cream)]/85">{x.title_b2}</span>
        </motion.h2>
        <motion.hr
          initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }} viewport={{ once: true }}
          transition={{ delay: 0.5, duration: 1.4, ease: "easeOut" }}
          className="hairline mx-auto mt-14 w-40 origin-center"
        />
        <motion.div
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ delay: 0.7, duration: 1 }}
          className="mt-14 max-w-[640px] mx-auto space-y-5"
        >
          <p className="font-display italic text-[19px] md:text-[24px] leading-[1.55] text-[var(--pn-milk)]/95">
            {x.pull_a}<br />{x.pull_b}
          </p>
          <p className="text-[15.5px] md:text-[17px] leading-[1.8] text-[var(--pn-cream)]/65 font-light">
            {x.p1}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
